
export class ResourceMapperService {
    public static robotType: Record<string, string> = {
        'Attended': 'RobotType_Attended',
        'Unattended': 'RobotType_Unattended',
        'NonProduction': 'RobotType_NonProduction',
        'Development': 'RobotType_Development',
        'StudioX': 'RobotType_StudioX',
    };

    public static sessionStatus: Record<string, string> = {
        'Available': 'RobotState_Available',
        'Busy': 'RobotState_Busy',
        'Disconnected': 'RobotState_Disconnected',
        'Unresponsive': 'RobotState_Unresponsive',
    };

    public static jobStatus: Record<string, string> = {
        'Successful': 'JobState_Successful',
        'Pending': 'JobState_Pending',
        'Running': 'JobState_Running',
        'Stopping': 'JobState_Stopping',
        'Terminating': 'JobState_Terminating',
        'Faulted': 'JobState_Faulted',
        'Stopped': 'JobState_Stopped',
    };

    public static transactionStatus: Record<string, string> = {
        'Successful': 'TransactionState_Successful',
        'Application Exceptions': 'TransactionState_ApplicationExceptions',
        'Business Exceptions': 'TransactionState_BusinessExceptions',
        'Total': 'TransactionState_Total',
    };
}
